<template>
  <DiscountPassVerification
    :show-form-level-error-message="true"
    :validation-params="validationParams"
    :disable-submit="!form.selfCert"
    v-on="$listeners"
  >
    <div
      slot="summary"
      class="info"
    >
      <h2 class="legend">
        Validate Eligibility
      </h2>
      <p>Check the box below to confirm that you are a student. Then, use your student email address to sign up for a bike share pass on the next page.</p>
      <p>Students must have a valid school email address to sign up for a discounted pass online.</p>
    </div>
    <template slot="eligibility-fields">
      <div class="checkbox">
        <input
          id="student-checkbox"
          v-model="form.selfCert"
          type="checkbox"
          class="checkbox__input"
          required
        >
        <label
          for="student-checkbox"
          class="checkbox__label"
        >I confirm that I currently enrolled as a student.</label>
      </div>
    </template>
    <div
      slot="details"
      class="info"
    >
      If you do not have a student email address, please visit <ExternalLink
        text=" TAPToGo.net"
        href="https://www.taptogo.net/"
      /> to apply for a Reduced Fare TAP Card. Then, you can use your TAP Card number to validate your eligibility for a reduced fare bike share pass.
    </div>
  </DiscountPassVerification>
</template>

<script>
import DiscountPassVerification from '../DiscountPassVerification.vue';
import ExternalLink from '../../ExternalLink.vue';

export default {
  components: { DiscountPassVerification, ExternalLink },
  data() {
    return {
      hasError: false,
      form: {
        selfCert: false,
      },
      validationParams: {
        validationType: 'self_certify',
      },
    };
  },
};
</script>
